import imgPrimario from "../../assets/images/2.jpg"
function PreInscripciones() {
  return (
    <div className="container">
      <h1 className="text-center display-6" style={{letterSpacing: "2px", color:"yellow"}}>Pre-inscripciones 2025</h1>
      <h1 className="text-center display-6" style={{letterSpacing: "2px"}}><strong>IMPORTANTE</strong></h1>
       <div className="">
          <p>
              Las pre-inscripciones 2025 se encuentran abiertas, para
              Nivel Inicial, Nivel Primario, Nivel Primario.
              Aclaración: Dicha planilla de Pre Inscripción debe ser entregada impresa en la sede
              del Nivel Primario (Neuquén 745) de 14 a 16 hs. Posteriormente se programarán las
              entrevistas con cada familia.
              Formulario Solicitud de Vacante de acuerdo al nivel:
          </p>
          <div className="row">
            <div className="col-sm-4 mt-4">
            <h5 className="card-title text-center mb-4 display-6">Inicial</h5>
              <div className="card"  style={{background:"transparent" , border:"none"}}>
                <div className="card-body d-flex justify-content-center">
                  <img src={imgPrimario} style={{width:"50%"}} className="card-img-top" alt="..."/>
                </div>
              </div>
            </div>
            <div className="col-sm-4 mt-4">
            <h5 className="card-title text-center mb-4 display-6">Primario</h5>
              <div className="card" style={{background:"transparent" , border:"none"}}>
                <div className="card-body d-flex justify-content-center">
                  <img src={imgPrimario} style={{width:"50%"}} className="card-img-top" alt="..."/>
                </div>
              </div>
            </div>
            <div className="col-sm-4 mt-4">
            <h5 className="card-title text-center mb-4 display-6">Secundario</h5>
              <div className="card"  style={{background:"transparent", border:"none"}}>
                <div className="card-body d-flex justify-content-center">
                  <img src={imgPrimario} style={{width:"50%"}} className="card-img-top" alt="..."/>
                </div>
              </div>
            </div>
            <p className="text-center">
            Aclaración: Dicha planilla de Pre Inscripción debe ser entregada impresa en la sede
            del Nivel Primario (Neuquén 745) de 14 a 16 hs. Posteriormente se programarán las
            entrevistas con cada familia.
          </p>
          </div>
        </div>
    </div>
  );
}

export default PreInscripciones;
